import {DomainAncestor, entityConfig, fieldInfo} from "core/common/domain/DomainAncestor";
import {observable, ObservableMap} from "mobx";
import {ID} from "core/metamodel/metaConstant";
import {IDomainObject} from "core/form/formUtils";
import {LovItem} from "core/metamodel/mdEntity";
import {decodeString, encodeString} from "core/common/utils/stringUtils";
import {GridDocument} from "core/document/gridDocument";
import {amber500, blue500} from "material-ui/styles/colors";
import {GridParams} from "core/grid/domain/grid";

export enum DOCUMENTLOCATION {
  Invoice = "Invoice",
}

export enum DOCUMENTSTATUS {
  REPLACED = "REPLACED",
  VALID = "VALID"
}

export enum DOCUMENTFORMAT {
  PDF = "PDF",
  PS = "PS",
  DOCX = "DOCX",
  DOC = "DOC",
  XLSX = "XLSX",
  XLS = "XLS",
  TXT = "TXT",
  CSV = "CSV",
  XML = "XML",
  XML_OBJECT = "XML_OBJECT",
  ZIP = "ZIP"
}

export enum CONTRACTTYPE {
  CUSTOMER_CONTRACT = "CUSTOMER_CONTRACT",
  DIRECT_DEBIT = "DIRECT_DEBIT"
}



export enum CONTRACTSTATUS {
  DRAFT = "DRAFT",
  SEND_FOR_SIGNING = "SEND_FOR_SIGNING",
  SIGNED = "SIGNED",
  EXPIRED = "EXPIRED",
  CANCELED = "CANCELED",
}

export const CONTRACTTYPE_MAP: {[key: string]: {backgroundColor: string}} = {
  [CONTRACTTYPE.CUSTOMER_CONTRACT]: {backgroundColor: blue500},
  [CONTRACTTYPE.DIRECT_DEBIT]: {backgroundColor: amber500}
};


@entityConfig()
export class DocumentType extends DomainAncestor {

  @observable documentTypeId: string;
  @observable documentName: string;
  @observable comment: string;
  @observable type: LovItem;


  @observable format: LovItem;
  @observable templateType: LovItem;
  @observable cardinality: LovItem;
  @observable langSource: LovItem;
  @observable location: LovItem;

  @observable tenantGroups: number[];
  @observable tenants: number[];
  @observable gridLocations: string[];


  constructor(json: IDomainObject) {
    super(json);

    if (!this.tenantGroups) this.tenantGroups = [];
    if (!this.tenants) this.tenants = [];
    if (!this.gridLocations) this.gridLocations = [];
  }


  public getId(): ID {
    return this.documentTypeId;
  }

  public setId(id: ID): void {
    this.documentTypeId = <any>id;
  }

}



@entityConfig()
export class DocumentTemplateResource extends DomainAncestor {

  @observable name: string;
  @observable lastModified: string|Date;
  @observable size: number;
  @observable contentType: string;
  @observable type: LovItem;
  @observable qualifyExpression: string;

  content: string;

  constructor(json: IDomainObject & {[key: string]: any}) {
    super(json);
  }
}



@entityConfig()
export class DocumentTemplate extends DomainAncestor {

  @observable documentType?: LovItem;
  @observable comment?: string;
  @observable validFrom?: string|Date;
  @observable validTo?: string|Date;
  @observable profitCenter?: LovItem;

  @observable invoiceTypeIds: LovItem[];

  @observable language?: LovItem;

  @observable useSaxonForXslt?: boolean;
  @observable documentNameExpression?: string;
  @observable templateIndex?: number;
  @observable templateStr?: string;
  template?: any;
  templateTypeId?: string;

  @observable @fieldInfo(DocumentTemplateResource) resources?: ObservableMap<DocumentTemplateResource>;
  @observable computations: LovItem[];

  constructor(json: IDomainObject) {
    super(json);
  }

  public fromJson(json: any): this {
    super.fromJson(json, "resources");

    if (!this.resources) this.resources = new ObservableMap<DocumentTemplateResource>();
    if (!this.computations) this.computations = [];
    if (!this.invoiceTypeIds) this.invoiceTypeIds = [];

    this.templateStr = (this.template) ? decodeString(this.template) : '';

    return this;
  }

  // musi zmenit klic mapy dle jmena uvnitr
  public prepareForServer(): this {
    this.resources = observable.map<DocumentTemplateResource>(this.resources.values().reduce((acc: any, value: DocumentTemplateResource) => {
      acc[value.name] = value;
      return acc;
    }, {}));
    this.template = encodeString(this.templateStr);
    return super.prepareForServer();
  }

}



@entityConfig()
export class Document extends DomainAncestor {

  @observable documentId: number;
  @observable documentUuid: string;
  @observable name: string;
  @observable documentType: LovItem;
  @observable icon: string;
  @observable status: DOCUMENTSTATUS;
  @observable includeAttachment?: boolean;
  @observable.ref replacementDocument: LovItem;
  data: any;

  constructor(json: IDomainObject) {
    super(json);
  }


  public getId(): ID {
    return this.documentId;
  }

  public setId(id: ID): void {
    this.documentId = <any>id;
  }

}


export interface DocumentCountDto {
  originalCount: number;
  documentCount: number;

  formats: LovItem[];
  selectedFormat?: string;
  duplexPrinting?: boolean;
  gridParams?: GridParams;
}

export interface DocumentPreviewDto {
  id: string;
  name: string;
  contentType: string;
}


@entityConfig()
export class Contract extends DomainAncestor {

  @observable contractId: number;
  @observable name: string;
  @observable comment: string;
  @observable contractNumber: string;
  @observable contractType: LovItem;
  @observable contractStatus: LovItem;
  @observable customer: LovItem;
  @observable sendForSigningDate: string|Date;
  @observable signingDate: string|Date;

  @observable $gridDocument: GridDocument;


  constructor(json: any) {
    super(json);
  }


  public getId(): ID {
    return this.contractId;
  }

  public setId(id: ID): void {
    this.contractId = <any>id;
  }

}

export const nonReplacedDocumentFp = (document: Document): boolean => (document.status !== DOCUMENTSTATUS.REPLACED);



// WEBPACK FOOTER //
// ./src/core/document/documentDomain.ts